export function selectUndoAction() {
  const { t } = useI18n();
  const viewerStore = useViewerStore();

  return {
    getTitle: () => t('components.xeokit_viewer.context_menu.undo_select') || 'Undo Select',

    getEnabled: function (context) {
      return context.entity.selected;
    },

    doAction: function (context) {
      context.entity.selected = false;

      if (viewerStore.propertiesInspector.metaObjects[context.entity.id]) {
        delete viewerStore.propertiesInspector.metaObjects[context.entity.id];
      }

      if (context.viewer.scene.numSelectedObjects === 0) {
        viewerStore.propertiesInspector.metaObjects = {};
      }
    },
  };
}
